query AdminDashboardToday {
  adminDashboardToday {
    activeContractsCount
    licenseContractsCount
    licenseContractsStartingLaterCount
    licensesMonthlyUSD
    endingSoonCount
    pendingRevenueShareUSD
  }
}
